import axios from '../../utils/axios';

export default function updateLGBillTarget(adminId, targetId, data) {
    return (
        axios.post(`/admin/${adminId}/lGBillTarget/${targetId}/update`,  data )
    )
}
